<template>
  <form @submit.prevent>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Accept Orders</p>
      </header>
      <section class="modal-card-body">
        <div class="pb-md border-b">
          <div class="columns is-vcentered">
            <div class="column">
              <p>Do you want to accept all orders?</p>
            </div>
            <div class="column is-narrow">
              <b-button
                type="is-primary rounded-lg"
                @click="acceptAll"
                :loading="busy"
                :disabled="busy"
              >Accept All Orders</b-button>
            </div>
          </div>
        </div>
        <!-- Results -->
        <div>
          <b-table
            :data="requests"
            :mobile-cards="false"
            hoverable
            class="is-size-7">
            <template>
              <!-- Label -->
              <b-table-column
                label="PO #"
                header-class="nowrap"
                cell-class="nowrap"
                width="128"
                v-slot="props">
                {{ props.row.label }}
              </b-table-column>
              <!-- Status -->
              <b-table-column
                label="Status"
                header-class="nowrap"
                cell-class="nowrap"
                v-slot="props">
                <p v-if="props.row.status === 'Done'" class="has-text-success">OK</p>
                <p v-else-if="props.row.status === 'Error'" class="has-text-danger">
                  Error: {{ props.row.errorMessage }}
                </p>
                <p v-else>{{ props.row.status }}</p>
              </b-table-column>
              <!-- Progress -->
              <b-table-column
                label=""
                header-class="nowrap"
                cell-class="nowrap"
                width="96"
                v-slot="props">
                <p v-if="props.row.status === 'Done'" class="has-text-success">OK</p>
                <p v-else-if="props.row.status === 'Ready' || props.row.status === 'Error'" class="has-text-success"></p>
                <b-progress v-else :type="props.row.progressType" show-value></b-progress>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$parent.close()">Close</button>
        <button class="button" type="button" @click="closeAndReload()">Close & Reload</button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {

  },
  data () {
    return {
      processing: false,
      requests: [],
      todo: 0,
      skipped: 0,
      success: 0,
      failed: 0
    }
  },
  computed: {
    ...mapGetters(['context']),
    busy () {
      return this.todo !== this.skipped + this.success + this.failed
    }
  },
  methods: {
    acceptAll () {
      this.reset()
      this.processing = true
      this.requests.forEach((request, index) => {
        this.todo++
        request.errorMessage = null
        setTimeout(() => {
          request.status = 'Pending'
          request.progressType = 'is-primary'
          request.errorMessage = null
          this.$http[request.method](request.endpoint).then(response => {
            this.success++
            request.status = 'Done'
            request.percent = 100
            request.progressType = 'is-success'
            response.statusCode = 200
            request.errorMessage = null
          }).catch(error => {
            this.failed++
            request.status = 'Error'
            request.percent = 100
            request.progressType = 'is-danger'
            request.statusCode = error.response.status
            request.errorMessage = error.response.data[0]
          })
        }, index * 1000)
      })
    },
    reset () {
      this.todo = this.skipped = this.success = this.failed = 0
      this.processing = false
    },
    closeAndReload () {
      this.$emit('reload')
      this.$parent.close()
    }
  },
  mounted () {
    this.orders.forEach(order => {
      this.requests.push({
        label: order.purchase_order_number,
        endpoint: this.context.route + '/orders/' + order.id + '/acknowledge/',
        valid: false,
        method: 'put',
        status: 'Ready',
        statusCode: null,
        errorMessage: null,
        progressType: 'is-primary'
      })
    })
  },
  props: ['orders']
}
</script>
